<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-09-05 17:11:59
 * @Description: 当月运营数据
 -->

<template>
  <div class="operation-data-wrapper">
    <div class="cur-data-wrapper">
      <img src="https://files.jinr.com/jinr-index/data-report/cur-data-01.jpg" alt="" srcset="" />
      <img src="https://files.jinr.com/jinr-index/data-report/cur-data-02.jpg" alt="" srcset="" />
      <img
        class="risk-management"
        src="https://files.jinr.com/jinr-index/data-report/cur-data-03.jpg"
        alt=""
        srcset=""
      />
      <img
        class="img-title"
        src="https://files.jinr.com/jinr-index/data-report/cur-data-04.png"
        alt=""
        srcset=""
      />
    </div>
    <div class="more clearfix">
      <a
        :href="
          `https://jinrfe.jinr.com/JydReport/index.html#/report?years=${currentData.year}&month=${
            item.month < 10 ? `0${item.month}` : item.month
          }`
        "
        v-for="(item, index) in currentData.list"
        :key="index"
        class="data-item"
      >
        <img src="https://files.jinr.com/jinr-index/img/data-report.png" alt="" srcset="" />
        <p class="year">{{ currentData.year }}</p>
        <p class="month">第{{ item.month }}月份</p>
        <p class="text">运营报告</p>
      </a>
    </div>
    <div class="check-more">
      <router-link class="btn" to="total">查看更多</router-link>
    </div>
  </div>
</template>
<script>
import dataList from './map.js';
export default {
  name: 'operation-data',
  computed: {
    currentData() {
      const tmp = dataList[0];
      return tmp;
    }
  }
};
</script>
<style lang="less" scope>
.operation-data-wrapper {
  background: #f2f2f2;
  .cur-data-wrapper {
    text-align: center;
    img {
      width: 100%;
    }
    .risk-management {
      margin: 20px 0;
    }
    .img-title {
      width: 560px;
    }
  }
  .more {
    width: 100%;
    padding: 10px 0;
    // display: flex;
    // flex-wrap: wrap;
    // background: #fff;
    .data-item {
      position: relative;
      float: left;
      width: 308px;
      height: 134px;
      margin: 2px;
      color: #fff;
      img {
        width: 100%;
      }
      .year {
        position: absolute;
        top: 46px;
        left: 66px;
        font-size: 26px;
        font-weight: 600;
      }
      .month {
        position: absolute;
        top: 82px;
        left: 62px;
        padding: 0px 10px;
        background: #fff;
        color: #247af1;
        border-radius: 10px;
        font-size: 12px;
      }
      .text {
        position: absolute;
        top: 40px;
        right: 20px;
        font-size: 30px;
      }
    }
  }
  .check-more {
    padding: 20px 0;
    background: #fff;
    .btn {
      display: block;
      width: 140px;
      text-align: center;
      margin: 0 auto;
      font-size: 20px;
      border: 2px solid #666;
      color: #666;
      cursor: pointer;
    }
  }
}
</style>
